import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyD6_2X7tbu4Ey872I4kEZvH7RuUp-9d0dk",
  authDomain: "instant-lighting.firebaseapp.com",
  databaseURL:
    "https://instant-lighting-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "instant-lighting",
  storageBucket: "instant-lighting.appspot.com",
  messagingSenderId: "1022221702621",
  appId: "1:1022221702621:web:df9d8f9d1ce49eaa6e9234",
  measurementId: "G-ECMMGWVTTM",
};

// Must match setGlobalOptions({ region }) in functions/index.js.
export const FUNCTIONS_REGION = "asia-east2";

// `REACT_APP_USE_EMULATORS=true npm start` runs the portal against local
// emulators (see DEPLOYMENT.md) under a demo project id, so it can never
// touch production data.
const useEmulators = process.env.REACT_APP_USE_EMULATORS === "true";

const app = initializeApp(
  useEmulators
    ? { ...firebaseConfig, projectId: "demo-keyportal" }
    : firebaseConfig,
);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, FUNCTIONS_REGION);

if (useEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}
